<div
  class="flex h-full w-full flex-col overflow-hidden bg-[#F8F6F2] sm:border-l sm:border-black/5 sm:shadow-[-8px_0_32px_rgba(0,0,0,0.06)]"
  [class]="closing() ? 'chat-slide-out-mobile' : 'chat-slide-in-mobile'"
>
  <bevvi-header
    class="shrink-0"
    [logo]="headerLogo()"
    (newChatClick)="startNewChat()"
    (closeClick)="close.emit()"
  />

  <bevvi-chat-body
    class="min-h-0 flex-1"
    [messages]="messages()"
    [loading]="loading()"
    (userReply)="onUserReply($event)"
  />

  <bevvi-chat-footer class="shrink-0" [loading]="loading()" (send)="sendMessage($event)" />
</div>
